/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './RoomStatusView.scss'
import React from 'react'
import { ListItem, SensorValue } from '../../atoms'
import { ListGroup } from '../../molecules'
import Cell from '../../templates/Cell'
import { NavigationDrawer } from 'ui-library/dist/external/components'

function RoomStatusView(props) {
  const toolbar = { label: '宿の情報', items: props.accountMenu }

  return (
    <div id="RoomStatus">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />
      <RoomInformationGroup>{props}</RoomInformationGroup>
    </div>
  )
}

function RoomInformationGroup(props) {
  return (
    <ListGroup border="underline">
      <ListItems>{props.children}</ListItems>
    </ListGroup>
  )
}

function ListItems(props) {
  return props.children.rooms ? props.children.rooms.map(v => <ListItem key={v.room.id}>{Item(v)}</ListItem>) : ''
}

function Item(rooms) {
  return rooms.sensors.length > 0 ? (
    <div className="hotel-item-row">
      {/* センサーが設置されている宿 */}
      <div className="row">
        <div className="col-md-12 col-lg-5 col-xl-5 align-self-center">
          <Cell className="name">
            <p className="hotel-name">{rooms.room.name}</p>
            {/*<p className="mb-0"><span className="label">宿泊者</span></p>*/}
          </Cell>
        </div>
        <div className="col-md-12 col-lg-7 col-xl-7 align-self-center">
          <div className="row">
            <div className="col-4 col-sm-3">
              <Cell className="sound">
                <p className="label pb-1">音量</p>
                <SensorValue type="sound" value={rooms.sensors[0].current_sound_level} />
              </Cell>
            </div>
            <div className="col-4 col-sm-3">
              <Cell className="temperature">
                <p className="label pb-1">室温</p>
                <SensorValue type="temperature" value={rooms.sensors[0].current_temperature} />
              </Cell>
            </div>
            <div className="col-4 col-sm-3">
              <Cell className="battery">
                <p className="label pb-1">バッテリー</p>
                <SensorValue type="battery" value={rooms.sensors[0].current_voltage} />
              </Cell>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="hotel-item-row">
      {/* センサーが設置されていない宿 */}
      <div className="row">
        <div className="col-md-12 col-lg-5 col-xl-5 my-1 align-self-center">
          <Cell className="name">
            <p className="hotel-name">{rooms.room.name}</p>
            {/*<p><span className="label">宿泊者</span> {room.guest}</p>*/}
          </Cell>
        </div>
        <div className="col-md-12 col-lg-7 col-xl-7 my-1 align-self-center">
          <Cell className="no-sensor">
            <p className="my-0">データがありません</p>
          </Cell>
        </div>
      </div>
    </div>
  )
}

export default RoomStatusView
